export const getDictionnaryLabelById = ({ id, dictionnary }) =>
  dictionnary.find(({ id: dictionnaryId }) => id === dictionnaryId)?.label ||
  'N/A'
export const getDictionnaryArabicLabelById = ({ id, dictionnary }) =>
  // eslint-disable-next-line camelcase
  dictionnary.find(({ id: dictionnaryId }) => id === dictionnaryId)?.label_ar ||
  'N/A'
  export const getDictionnaryArabicWilayaLabelById = ({ id, dictionnary }) =>
  // eslint-disable-next-line camelcase
  dictionnary.find(({ id: dictionnaryId }) => id === dictionnaryId)?.name_ar ||
  'N/A'
  
